<template>
  <div class="mt-6">
    <jade-box>
      <div class="mb-2">
        <JadeGroupHeader>
          {{ $t('terminals') }}
        </JadeGroupHeader>
      </div>

      <div
        v-if="loading"
        class="eu-pa_6 eu-align_center"
        data-testid="show-loading"
      >
        <emd-loader type="_invert" />
      </div>

      <div v-else>
        <empty-list
          v-if="showEmptyList"
          entity="physical-world-list"
          svg="pos"
          data-testid="show-empty"
        />

        <empty-list-filter
          v-else-if="showEmptyListFilter"
          entity="pos"
        />

        <div v-else>
          <terminals-list-item
            v-for="(item, index) in items"
            :key="item.id"
            :source="item"
            :index="index"
          />
          <div class="p-5">
            <jade-pagination
              :disabledPrevious="pagination.current_page === 1"
              :disabledNext="pagination.current_page === pagination.total_page"
              @onPrevious="() => $emit('onPrevious')"
              @onNext="() => $emit('onNext')"
            >
              <jade-text>
                {{ pagination.current_page }} de {{ pagination.total_page }}
              </jade-text>
            </jade-pagination>
          </div>
        </div>
      </div>
    </jade-box>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { EmdLoader } from 'emerald-vue/src/components'

import { JadeGroupHeader, JadeBox, JadePagination, JadeText } from '@jade'

export default {
  name: 'TerminalsList',
  components: {
    JadeGroupHeader,
    JadeBox,
    EmdLoader,
    JadePagination,
    JadeText,
    TerminalsListItem: () => import('./TerminalsListItem.vue'),
    EmptyList: () => import('@/components/project/globals/EmptyList.vue'),
    EmptyListFilter: () =>
      import('@/components/project/globals/EmptyListFilter.vue')
  },
  props: {
    items: Array,
    pagination: Object,
    loading: Boolean
  },
  data () {
    return {
      isOpen: false
    }
  },
  computed: {
    ...mapGetters(['permissionIsEnabled']),
    isEmptyList () {
      return !this.loading && this.items?.length === 0
    },
    showEmptyList () {
      return this.isEmptyList && Object.entries(this.$route.query).length <= 2
    },
    showEmptyListFilter () {
      return this.isEmptyList && Object.entries(this.$route.query).length > 2
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "terminals": "Lista de maquininhas"
    },
    "en-US": {
      "terminals": "Terminals List"
    }
  }
</i18n>
